import type {SingleAcceptableValueEditorLocalizations, SingleAcceptableValueEditorOptions} from './types';
import type {DefaultOptions} from '../../../types';
import FlattenedTreeSupportingOptionLabel from '../_shared/FlattenedTreeSupportingOptionLabel.svelte';
import type {SvelteComponentConstructor} from 'core/types';

export const SINGLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_OPTIONS: DefaultOptions<SingleAcceptableValueEditorOptions<any>> = {
    acceptableValues: [],
    switchToInlineModeThreshold: 13,
    modelAsArray: false,
    allowSelectNull: false,
    blockInRow: false,
    optionLabelComponent: FlattenedTreeSupportingOptionLabel as SvelteComponentConstructor<{option, usedAsLabel?}>,
    optionIdResolver: ({option}) => option,
    sortComparator: undefined,
    optionDisabledResolver: () => false,
};

/**
 * @ngdoc constant
 * @name SINGLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS
 * @module portaro.value-editors.single-acceptable
 *
 * @description
 * ```
 * {
 *     description: '',
 *     noneOfTheOptions: 'None of the options',
 * }
 * ```
 */
export const SINGLE_ACCEPTABLE_VALUE_EDITOR_DEFAULT_LOCALIZATIONS = Object.freeze<SingleAcceptableValueEditorLocalizations>({
    description: '',
    noneOfTheOptions: 'None of the options',
});